import { Collection, MixinInterface } from "@mcleod/core";
import { CaptionLabel } from "../components/label/CaptionLabel";
import { Component, LabelProps } from "..";
import { LabelVariant } from "../components/label/LabelVariant";
import { ListenerListDef } from "../base/ListenerListDef";

export class CaptionedMixin extends Component implements MixinInterface {
    private _caption: string = "";
    private _captionLabel: CaptionLabel;

    get name(): string {
        return "Captioned";
    }

    initialize() {
    }

    get listenerDefs(): Collection<ListenerListDef> {
        return null;
    }

    get caption(): string {
        return this._caption;
    }

    set caption(value: string) {
        if (this.captionValueMatches(value) === true) {
            return;
        }
        this._caption = value;
    }

    get captionLabel(): CaptionLabel {
        return this._captionLabel
    }

    set captionLabel(value: CaptionLabel) {
        this._captionLabel = value;
    }

    get captionLabelProps(): Partial<LabelProps> {
        return {
            variant: LabelVariant.caption
        };
    }

    captionValueMatches(value: string) {
        return this._caption === value;
    }

    private getCaptionPrefix(): string {
        return this.required === true && this["printable"] !== true ? "*" : "";
    }

    getPrefixedCaption(): string {
        const prefix = this.getCaptionPrefix();
        if (this.caption != null && !this.caption.startsWith(prefix)) {
            return prefix + this.caption;
        }
        return this.caption;
    }
}
